export enum UILocale {
  NOT_SPECIFIED = '',
  EN_US = 'en-US',
  FR_CA = 'fr-CA',
  EN_CA = 'en-CA',
  ES_US = 'es-US',
}
